import { useCallback, useState } from 'react';

const noop = () => {};

function useSummarizedFilteredRows(onSummaryChange = noop) {
  const [filteredRows, setFilteredRows] = useState([]);

  const setFilteredRowsWithSummary = useCallback((nextRows) => {
    setFilteredRows(nextRows);
    onSummaryChange({ total: nextRows.length });
  }, [onSummaryChange]);

  return [filteredRows, setFilteredRowsWithSummary];
}

export default useSummarizedFilteredRows;
